import axios from 'axios';
import { authStore } from '../store/auth';
import { userStore } from '../store/user';
import { messageStore } from '../store/message';


console.log('API_URL', process.env.REACT_APP_API_URL);
const ApiUrl = process.env.REACT_APP_API_URL;

const API = axios.create({ baseURL: ApiUrl, timeout: 20000 });

const handleRequest = async (config) => {
  const auth = authStore.getState();

  const accessToken = auth?.accessToken;
  if (accessToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
};

const handleError = async (error) => {
  const status = error?.request?.status;
  if (status === 403) {
    window.location.href = '/403';
  }

  if (status === 500) {
    window.location.href = '/500';
  }

  if (status === 401) {
    const auth = authStore.getState();
    const user = userStore.getState();
    const message = messageStore.getState();

    // logout user
    message.setMessage('Your session has expired. Please login again.');
    auth.handleLogout();
    user.resetUser();
  }
};

API.interceptors.request.use(handleRequest);
API.interceptors.response.use(
  (response) => response,
  (error) => handleError(error),
);

export default API;
